export enum Features {
  BOOKINGS_EXCLUDE_CUSTOMERS = 'bookings.excluded-customers',
  QUOTE_REQUEST_FCL_CRD = 'ship.quote-request-fcl-crd',
  SHOW_DEFAULT_FOR_INTEGRATIONS_IN_LEGAL_ENTITY = 'cftmasterdata.showDefaultForIntegrationsInLEs',
  LOCAL_CURRENCY_DISPLAY = 'cft-booking.ship.local-currency-display',
  NEW_RATE_FILTERS = 'cft-booking.ship.new-rate-filters',
  BOOKING_ACCEPTANCE_REQUIREMENTS = 'tms.booking.acceptance-requirements',

  // FFs owned by Insights And Integrations
  DEM_DET = 'cft-insights.mot.dem_det', // Operational FF to blacklist customers from using DEM/DET
  COMPANY_ACCOUNT_PAGE = 'cft-insights.ship-v2.company-account-page', // FF to enable the company account page

  SHIPMENT_OVERVIEW_DEM_DET_TAB = 'cft-shipping.ship.shipment-overview-demdet_tab',
  TRANSPORT_PLAN_PORTS = 'transport-network.ports',
  TRADE_FINANCE_BANNER = 'ship.trade-finance-banner',
  INTEGRATIONS_ENABLED = 'cftcustomersintegrations.newui',
  ALLOW_SYRIA_IN_BOOKING_RESTRICTED_COUNTRIES = 'cft-booking.ship.allow-syria-in-restricted-countries',
  SHIPMENT_IOT_TRACKING_TAB = 'cft-shipping.ship.iot-tracking',
  ENABLE_BILLING_CORE_INVOICE = 'billing.enable.billing-core.invoice',
  DOCUMENTS_V2 = 'paw.ship.documents-v2',
  SHIPMENT_TAGS = 'tms.shipment.tags',

  SHIP_V2_BETA = 'ship-v2.release.beta',

  // FFs owned by PAW
  NEW_REQUIRED_ACTIONS_MODELS = 'paw.ship.new-required-actions-models',

  // FFs owned by Booking
  BOOKING_NEW_ADDRESS_ID = 'booking.ship-v2-new-address-id',

  // FFs owned by Shipping
  EDIT_GENERAL_INFORMATION = 'ship-v2.edit-general-information',
  UNIFIED_SHIPMENTS = 'ship-v2.unified-shipments',
  FREE_TEXT_BOOKING = `ship-v2.free-text-booking`,

  MULTIPLE_COMMODITIES_UN_NUMBERS = 'ship-v2.container-details.multiple-commodities-un-numbers',
}
